import { motion } from 'framer-motion';

interface Props {
  size?: number;
  className?: string;
}

/**
 * Animated word-mark. The dot in "i" pulses to give the impression of a
 * listening ear — "声音即笔记".
 */
export function Logo({ size = 28, className }: Props) {
  return (
    <div
      className={className}
      style={{
        fontSize: size,
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.05em',
        fontWeight: 600,
        letterSpacing: '-0.02em',
      }}
    >
      <span className="text-gradient">M</span>
      <span>ind</span>
      <span className="relative inline-flex">
        <span>F</span>
        <span className="relative">l</span>
        <span className="relative inline-block">
          o
          <motion.span
            className="absolute inset-0 rounded-full bg-gradient-to-br from-accent to-accent-2"
            style={{ opacity: 0.15, filter: 'blur(6px)' }}
            animate={{ scale: [1, 1.15, 1] }}
            transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
          />
        </span>
        <span>w</span>
      </span>
    </div>
  );
}
